<template>
    <div class="menu">
        <div class="logo-box">
            <img src="../assets/logo.png" class="logo">
            <span>EXTEND TECH PTE. LTD.</span>
        </div>
        <div class="menu-box">
            <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME </div>
            <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">OUR PROJECTS</div>
            <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">TEAM</div>
            <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">CONTACT US</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "Projects" }); break;
                case 3: this.$router.push({ path: "Team" }); break;
                case 4: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 10px 360px;
    background: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-box {
        display: flex;
        align-items: center;

        span {
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            margin-left: 10px;
        }
    }

    .logo {
        // width: 242px;
        height: 40px;
    }

    .menu-box {
        display: flex;
        width: 500px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
    }

    .select {
        background: #3DA685;
        border-radius: 8px;
        padding: 0px 25px;
    }
}
</style>